import { render, staticRenderFns } from "./LeaderBoardTable.vue?vue&type=template&id=5f5d3b7a&scoped=true&"
import script from "./LeaderBoardTable.vue?vue&type=script&lang=js&"
export * from "./LeaderBoardTable.vue?vue&type=script&lang=js&"
import style0 from "./LeaderBoardTable.vue?vue&type=style&index=0&id=5f5d3b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d3b7a",
  null
  
)

export default component.exports